import { useTranslation } from 'react-i18next';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <section id="contact" className="bg-white py-20 md:py-28" aria-labelledby="contact-heading">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-3xl mx-auto text-center">
        <div className="flex items-center justify-center gap-3 mb-4">
          <span className="w-8 h-px bg-gold-400" aria-hidden="true"></span>
          <p className="text-gold-500 text-xs md:text-sm font-semibold tracking-[0.25em] uppercase">
            {t('contact_label')}
          </p>
          <span className="w-8 h-px bg-gold-400" aria-hidden="true"></span>
        </div>
        <h2 id="contact-heading" className="text-2xl md:text-4xl lg:text-[2.75rem] font-bold text-navy-900 leading-tight mb-4">
          {t('contact_title')}
        </h2>
        <p className="text-sm md:text-base text-gray-600 leading-[1.8] mb-10 md:mb-14">
          {t('contact_desc')}
        </p>

        <div
          className="bg-navy-50 rounded-sm p-8 md:p-12 border border-gold-100/50 space-y-10"
          itemScope
          itemType="https://schema.org/ContactPoint"
        >
          <meta itemProp="contactType" content="customer service" />
          <meta itemProp="availableLanguage" content="English, Japanese, Khmer" />

          <div>
            <div className="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-full bg-white border border-gold-200/50">
              <i className="ri-mail-send-line text-2xl md:text-3xl text-gold-500"></i>
            </div>

            <p className="text-xs md:text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
              {t('contact_email_label')}
            </p>
            <a
              href="mailto:mail@lavstyle.net"
              className="text-lg md:text-xl lg:text-2xl font-semibold text-navy-800 hover:text-gold-600 transition-colors cursor-pointer inline-flex items-center gap-2"
              itemProp="email"
            >
              <i className="ri-mail-line text-lg md:text-xl"></i>
              mail@lavstyle.net
            </a>
          </div>

          <div className="border-t border-gold-200/40 pt-10">
            <div className="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-full bg-white border border-gold-200/50">
              <i className="ri-phone-line text-2xl md:text-3xl text-gold-500"></i>
            </div>

            <p className="text-xs md:text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
              {t('contact_phone_label')}
            </p>
            <a
              href="tel:+85516225436"
              className="text-lg md:text-xl lg:text-2xl font-semibold text-navy-800 hover:text-gold-600 transition-colors cursor-pointer inline-flex items-center gap-2"
              itemProp="telephone"
            >
              <i className="ri-phone-line text-lg md:text-xl"></i>
              016 225 436
            </a>
          </div>

          <p className="text-xs md:text-sm text-gray-500 max-w-md mx-auto">
            {t('contact_guidance')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
